module.exports = __webpack_public_path__ + "static/media/ios-tablet-landscape.b39f0d6b.svg";